import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type FeedbackTranslations = {
  [lang: string]: Translation;
};

export const feedbackTranslations: FeedbackTranslations = {
  en,
};
